export default (ctx, inject) => {
  const store = {
    timers: new Map(),
  }

  inject('req', store)

  ctx.app.$req = store
}
